// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';               // загружаем i18n до рендера
import i18n from 'i18next';
import ErrorBoundary from './components/ErrorBoundary';

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng || 'ru';
  }
});

// Глобальные ловушки JS-ошибок вне React-рендера
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    // eslint-disable-next-line no-console
    console.error('[window.onerror]', e.error || e.message || e);
  });
  window.addEventListener('unhandledrejection', (e) => {
    // eslint-disable-next-line no-console
    console.error('[unhandledrejection]', e.reason || e);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
